export type FaqItem = {
  question: string
  answer: string
}

export const faqItems: FaqItem[] = [
  {
    question: '¿Qué recibo después de comprar?',
    answer:
      'Recibís acceso digital a Europa por Primera Vez y a todos los recursos incluidos: rutas, planners editables, presupuesto, checklist, apps, errores a evitar y equipaje inteligente.',
  },
  {
    question: '¿Es un producto físico?',
    answer:
      'No. Todo el contenido es 100% digital y podés acceder inmediatamente después de la compra.',
  },
  {
    question: '¿Me sirve si todavía no compré el vuelo?',
    answer:
      'Sí. De hecho, es uno de los mejores momentos para usarla porque todavía estás definiendo fechas, presupuesto y recorrido.',
  },
  {
    question: '¿Las rutas son obligatorias?',
    answer:
      'No. Las 19 rutas son modelos para ayudarte a empezar. Podés adaptarlas según tus días, destinos, presupuesto y preferencias.',
  },
  {
    question: '¿Necesito saber usar Excel?',
    answer:
      'No. Las plantillas están preparadas para ser simples de completar y varias partes incluyen cálculos automáticos.',
  },
  {
    question: '¿Por qué usar esta guía si puedo buscar información online o preguntarle a una IA?',
    answer:
      'Porque encontrar información es solo una parte del proceso. Esta guía organiza todo dentro de un sistema práctico y suma aprendizajes basados en experiencias reales de viaje para ayudarte a tomar mejores decisiones.',
  },
]
